import { SetStateAction } from 'react'
import { useApiSubscription } from './use-api-subscription'
import { Contract, isMultiCpmmMechanism } from 'common/contract'
import { Answer } from 'common/answer'
import { uniqBy } from 'lodash'
export const useContractUpdates = <C extends Contract | Pick<Contract, 'id'>>(
  initial: C,
  setContract: (value: SetStateAction<C>) => void
) => {
  useApiSubscription({
    topics: [`contract/${initial.id}/new-answer`],
    enabled: 'mechanism' in initial && isMultiCpmmMechanism(initial.mechanism),
    onBroadcast: ({ data }) => {
      setContract((contract) => {
        return {
          ...contract,
          answers: uniqBy(
            [
              ...('answers' in contract ? contract.answers : []),
              data.answer as Answer,
            ],
            'id'
          ),
        }
      })
    },
  })

  useApiSubscription({
    topics: [`contract/${initial.id}/updated-answers`],
    enabled: 'mechanism' in initial && isMultiCpmmMechanism(initial.mechanism),
    onBroadcast: ({ data }) => {
      const newAnswerUpdates = data.answers as (Partial<Answer> & {
        id: string
      })[]
      setContract((contract) => {
        return {
          ...contract,
          answers: ('answers' in contract ? contract.answers : []).map(
            (answer) => {
              const update = newAnswerUpdates.find(
                (newAnswer) => newAnswer.id === answer.id
              )
              if (!update) return answer
              return {
                ...answer,
                ...update,
                ...('resolution' in update
                  ? { resolution: update.resolution ?? undefined }
                  : {}),
                ...('resolutionTime' in update
                  ? { resolutionTime: update.resolutionTime ?? undefined }
                  : {}),
                ...('resolutionProbability' in update
                  ? {
                      resolutionProbability:
                        update.resolutionProbability ?? undefined,
                    }
                  : {}),
                ...('resolverId' in update
                  ? { resolverId: update.resolverId ?? undefined }
                  : {}),
              }
            }
          ),
        }
      })
    },
  })

  useApiSubscription({
    topics: [`contract/${initial.id}`],
    onBroadcast: ({ data }) => {
      setContract((contract) => {
        return { ...contract, ...(data.contract as C) }
      })
    },
  })
}
